import { render, staticRenderFns } from "./MzLabyrinth2.vue?vue&type=template&id=740c1fbc&scoped=true&"
import script from "./MzLabyrinth2.vue?vue&type=script&lang=js&"
export * from "./MzLabyrinth2.vue?vue&type=script&lang=js&"
import style0 from "./MzLabyrinth2.vue?vue&type=style&index=0&id=740c1fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740c1fbc",
  null
  
)

export default component.exports